// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `weChat/index${i + 1}`,
  name: `weChatIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/weChat/index${i + 1}.vue`)
}))

const BranchRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `weChat/branch/index${i + 1}`,
  name: `weChatBranchIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/weChat/branch/index${i + 1}.vue`)
}))


export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,
    ...BranchRoutes,


  ],
};
